import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Routing} from 'nutshell-core/routing';

// @ts-expect-error - imported from .js/.jsx file

import {ExternalLinkIcon} from 'shells/icon/svg/external-link-icon';
import {Link} from 'shells/link/link';

export function getInProgressMessage(
    isContactSyncInProgress: boolean,
    isMessageSyncInProgress: boolean
): string {
    if (isContactSyncInProgress && isMessageSyncInProgress) {
        return 'We’re syncing your contacts and chat history';
    }
    if (isContactSyncInProgress) {
        return 'We’re syncing your contacts';
    }
    if (isMessageSyncInProgress) {
        return 'We’re syncing your chat history';
    }

    return '';
}

export function getCompletionMessage(
    isContactSyncCompleted: boolean,
    isMessageSyncCompleted: boolean
): string {
    if (isContactSyncCompleted && isMessageSyncCompleted) {
        return 'Your contacts and chat history sync is complete.';
    }
    if (isContactSyncCompleted) {
        return 'Your contacts sync is complete.';
    }
    if (isMessageSyncCompleted) {
        return 'Your chat history sync is complete.';
    }

    return '';
}

export function getFailureMessage(
    isContactSyncFailed: boolean,
    isMessageSyncFailed: boolean,
    contactError?: string | null,
    messageError?: string | null
): string {
    const failedItems = [];
    let errorMessage = '';

    if (isContactSyncFailed) {
        failedItems.push('contacts');
        errorMessage = contactError || 'Unknown error occurred';
    }

    if (isMessageSyncFailed) {
        failedItems.push('chat history');
        if (!errorMessage) {
            errorMessage = messageError || 'Unknown error occurred';
        }
    }

    return `Failed to sync ${failedItems.join(' and ')}: ${errorMessage}`;
}

export function getPrimaryAction(
    isContactSyncCompleted: boolean,
    isMessageSyncCompleted: boolean,
    originId: string
): React.ReactElement | null {
    if (isContactSyncCompleted) {
        const getContactsLink = () => {
            const filter = Routing.param({
                filter: {
                    origin: {
                        anyAll: 'any',
                        data: [{data: originId}],
                    },
                },
            });

            return `/people?${filter}&view=list`;
        };

        return (
            <Link
                // @ts-expect-error
                as={RoutedLink}
                variant='primary'
                size='small'
                to={getContactsLink()}
                // @ts-expect-error
                onClick={(e, handleClose) => handleClose && handleClose()}
            >
                View contacts
            </Link>
        );
    }

    if (isMessageSyncCompleted) {
        return (
            <Link
                // @ts-expect-error
                as={RoutedLink}
                variant='primary'
                size='small'
                to='/inbox/whatsapp'
                // @ts-expect-error
                onClick={(e, handleClose) => handleClose && handleClose()}
            >
                View WhatsApp inbox
            </Link>
        );
    }

    return null;
}

export function getHelpLink(): React.ReactElement {
    return (
        <Link
            href='https://support.nutshell.com/en/articles/11487542-whatsapp-send-receive-messages-from-nutshell'
            target='_blank noopener noreferrer'
            variant='primary'
            size='small'
            // @ts-expect-error
            onClick={(e, handleClose) => handleClose && handleClose()}
            icon={ExternalLinkIcon}
        >
            Learn how to fix this
        </Link>
    );
}
